import useEventCallback from '@restart/hooks/useEventCallback';
import useMergedRefs from '@restart/hooks/useMergedRefs';
import { cloneElement, useEffect, useRef } from 'react';

function NoopTransition(_ref) {
  var children = _ref.children,
      inProp = _ref.in,
      onExited = _ref.onExited,
      mountOnEnter = _ref.mountOnEnter,
      unmountOnExit = _ref.unmountOnExit;
  var ref = useRef(null);
  var hasEnteredRef = useRef(inProp);
  var handleExited = useEventCallback(onExited);
  useEffect(function () {
    if (inProp) hasEnteredRef.current = true;else {
      handleExited(ref.current);
    }
  }, [inProp, handleExited]);
  var combinedRef = useMergedRefs(ref, children.ref);
  var child = /*#__PURE__*/cloneElement(children, {
    ref: combinedRef
  });
  if (inProp) return child;

  if (unmountOnExit) {
    return null;
  }

  if (!hasEnteredRef.current && mountOnEnter) {
    return null;
  }

  return child;
}

export default NoopTransition;